import appConfig from 'configs/app.config'
import getAuthHeader from 'utils/getAuthHeader'
const { apiPrefixServer } = appConfig


export function getLogin(data){
    console.log(data)
    const url=`${apiPrefixServer}/v1/user/loginapp`;
    const params={
        method:"POST",
        body:JSON.stringify(data),
        headers:{
            "Content-Type":"application/json"
        }
    };
    return fetch(url,params)
    .then(response=>{
        return response.json();
    })
    .then(result=>{
        return result;
    })
    .catch(err=>{
        return err.message;
    });
}


//funcion para tomar los usuarios
export function getUsers(companyid) {
    const url = `${apiPrefixServer}/v1/user/search`;
    const params = {
        method: "GET",
        headers: getAuthHeader()
    };

    return fetch(url, params)
        .then(response => {
            return response.json();
        })
        .then(result => {
            return result;
        })
        .catch(err => {
            return err.message;
        });
}

export function getUser(id) {
    const url = `${apiPrefixServer}/v1/get-user/${id}`;
    const params = {
        method: "GET",
        headers: getAuthHeader()
    };
    return fetch(url, params)
        .then(response => {
            return response.json();
        })
        .then(result => {
            return result;
        })
        .catch(err => {
            return err.message;
        });
}

export function createUser(data){
    const url=`${apiPrefixServer}/v1/post-user`;
    const params={
        method:"POST",
        body:JSON.stringify(data),
        headers: getAuthHeader()
    };
    return fetch(url,params)
    .then(response=>{
        return response.json();
    })
    .then(result=>{
        return result;
    })
    .catch(err=>{
        return err.message;
    });
}


export function updateUser(data, id){ 

    const url=`${apiPrefixServer}/v1/update-user/${id}`;
    const params={
        method:"PUT",
        headers: getAuthHeader(),
        body: JSON.stringify(data)
    };
    return fetch(url,params)
    .then(response=>{
        return response.json();
    })
    .then(result=>{
        return result;
    })
    .catch(err=>{
        return err.message;
    });
}


export function deleteUser(id){
    const url=`${apiPrefixServer}/v1/delete-user/${id}`;
    const params ={
        method: "DELETE",
        headers: getAuthHeader()
    }
    return fetch(url,params)
    .then(response => {
        return response.json();
    })
    .then(result=>{
        return result.message;
    })
    .catch(err=>{
        return err.message;
    })
}


